import React from 'react';
import { Flex, Input, IconButton } from '@chakra-ui/react';
import { ArrowRight } from 'phosphor-react';

interface ChatInputProps {
  input: string;
  setInput: (value: string) => void;
  handleSendMessage: () => void;
  isLoading: boolean;
  onKeyPress: (e: React.KeyboardEvent) => void;
}

const ChatInput = ({ input, setInput, handleSendMessage, isLoading, onKeyPress }: ChatInputProps): JSX.Element => (
  <Flex
    p={4}
    bg="white"
    borderRadius="lg"
    mt={4}
    width="60%"
    alignSelf="center"
    boxShadow="sm"
    border="1px"
    borderColor="gray.200"
  >
    <Input
      flex={1}
      bg="white"
      border="none"
      color="gray.800"
      placeholder={isLoading ? 'Please wait...' : "Ask about Bureau's services..."}
      _placeholder={{ color: 'gray.400' }}
      mr={2}
      value={input}
      onChange={e => setInput(e.target.value)}
      onKeyPress={onKeyPress}
      fontFamily="Lexend"
      fontSize="sm"
      fontWeight="light"
      isDisabled={isLoading}
    />
    <IconButton
      aria-label="Send message"
      icon={<ArrowRight size={20} />}
      colorScheme="blue"
      isLoading={isLoading}
      onClick={handleSendMessage}
      isDisabled={isLoading}
    />
  </Flex>
);

export default ChatInput;
